module.exports = __webpack_public_path__ + "fonts/HSESans-Regular.53b84a0.otf";